// English translations for the admin-config area, keyed by the Russian source string.
export default {
  // General / actions
  'Настройки': 'Settings',
  'Сохранить': 'Save',
  'Добавить': 'Add',
  'Удалить': 'Delete',
  'Удалить?': 'Delete?',
  'Отмена': 'Cancel',
  'Действие': 'Action',
  'Статус': 'Status',
  'Название': 'Name',
  'Содержание': 'Content',
  'Тема': 'Subject',
  'Тип': 'Type',
  'Цена': 'Price',
  'Порядок': 'Order',
  'Телефон': 'Phone',
  'Адрес': 'Address',
  'Страна': 'Country',
  'Изображение': 'Image',
  'Активный': 'Active',
  'Нет данных': 'No data',
  'Показать только активные': 'Show only active',
  'Загрузить изображение': 'Upload image',
  'содержание': 'content',
  'кг': 'kg',
  'груз': 'cargo',
  'цифр!': 'digits!',
  'успешно добавлен': 'added successfully',
  'успешно изменён': 'updated successfully',
  'успешно удалён': 'deleted successfully',

  // Banners
  'Баннер': 'Banner',
  'Список баннеров': 'Banner list',
  'Добавить баннер': 'Add banner',
  'Информация о баннере': 'Banner details',
  'Вы уверены, что хотите удалить этот баннер?': 'Are you sure you want to delete this banner?',
  'Баннер успешно удалён!': 'Banner deleted successfully!',
  'Баннер успешно изменён!': 'Banner updated successfully!',
  'Новый баннер успешно добавлен!': 'New banner added successfully!',
  'Загрузите изображение баннера!': 'Upload a banner image!',
  'Можно загружать только файлы JPG/PNG!': 'You can only upload JPG/PNG files!',
  'Изображение должно быть меньше 5 МБ!': 'The image must be smaller than 5 MB!',

  // Branches
  'Список филиалов': 'Branch list',
  'Добавить филиал': 'Add branch',
  'Информация о филиалах': 'Branch information',
  'Информация о филиале': 'Branch details',
  'Удаление филиала!': 'Delete branch!',
  'Вы собираетесь удалить информацию о филиале. Продолжить?': 'You are about to delete the branch information. Continue?',
  'Филиал успешно удалён': 'Branch deleted successfully',
  'Информация о филиале успешно сохранена!': 'Branch information saved successfully!',
  'Новый филиал успешно добавлен!': 'New branch added successfully!',
  'Страна филиала': 'Branch country',
  'Выберите страну!': 'Select a country!',
  'Введите название филиала!': 'Enter the branch name!',
  'Введите адрес филиала': 'Enter the branch address',
  'Введите номер телефона!': 'Enter a phone number!',
  'Номер телефона должен состоять из': 'The phone number must contain',
  'Буква филиала': 'Branch letter',
  'Введите букву филиала': 'Enter the branch letter',
  'Введите цену за 1 кг груза': 'Enter the price per 1 kg of cargo',
  'Введите порядковый номер': 'Enter the sort order',
  'Онлайн-груз': 'Online cargo',
  'Принимать онлайн-грузы': 'Accept online cargo',
  'Тип доставки': 'Delivery type',
  'Выберите тип доставки!': 'Select a delivery type!',
  'Список сотрудников': 'Employee list',
  'Добавить сотрудника': 'Add employee',
  'Сотрудники не найдены': 'No employees found',
  'Выберите сотрудника!': 'Select an employee!',
  'Ответственный сотрудник': 'Responsible employee',
  'Выберите хотя бы одного сотрудника!': 'Select at least one employee!',
  'Авиа': 'Air',
  'Земля': 'Ground',

  // Branch table
  'Тип груза': 'Cargo type',
  'Приём онлайн-грузов': 'Online cargo acceptance',
  'Приём онлайн-грузов доступен': 'Online cargo acceptance available',
  'Приём онлайн-грузов недоступен': 'Online cargo acceptance unavailable',
  'Авиагруз': 'Air cargo',
  'Наземный груз': 'Ground cargo',
  'Морской груз': 'Sea cargo',
  'Контейнерный груз': 'Container cargo',
  'Груз другого типа': 'Other cargo type',

  // Email templates
  'Шаблон Email': 'Email template',
  'Список шаблонов Email': 'Email template list',
  'Информация Email': 'Email details',
  'Информация Email успешно изменена!': 'Email details updated successfully!',
  'Введите тему!': 'Enter the subject!',

  // SMS templates
  'Шаблон SMS': 'SMS template',
  'Список шаблонов SMS': 'SMS template list',
  'Информация SMS': 'SMS details',
  'Информация SMS успешно изменена!': 'SMS details updated successfully!',
  'Длина сообщения': 'Message length',

  // Order item types
  'Тип отправления': 'Shipment type',
  'Список типов отправлений': 'Shipment type list',
  'Добавить тип': 'Add type',
  'Редактировать тип отправления': 'Edit shipment type',
  'Вы уверены, что хотите удалить этот тип отправления?': 'Are you sure you want to delete this shipment type?',
  'Тип отправления успешно удалён!': 'Shipment type deleted successfully!',
  'Тип отправления успешно изменён': 'Shipment type updated successfully',
  'Тип отправления успешно добавлен': 'Shipment type added successfully',
  'Поиск по названию, типу': 'Search by name, type',
  'Выберите тип': 'Select a type',
  'Выберите тип!': 'Select a type!',

  // U-Post types
  'Вы уверены, что хотите удалить этот тип': 'Are you sure you want to delete this',
  'Редактировать тип': 'Edit type',

  // Validation / status
  'Введите название!': 'Enter a name!',
  'Введите содержание!': 'Enter the content!',
  'Статус успешно изменён': 'Status updated successfully',
  // SMTP settings
  'Настройки SMTP': 'SMTP settings',
  'SMTP-сервер': 'SMTP server',
  'Порт': 'Port',
  'Пароль': 'Password',
  'Отправить': 'Send',
  'Адрес отправителя': 'From address',
  'Имя отправителя': 'From name',
  'Использовать SSL/TLS': 'Use SSL/TLS',
  'Префикс темы': 'Subject prefix',
  'Введите адрес SMTP-сервера!': 'Enter the SMTP server address!',
  'Введите порт!': 'Enter the port!',
  'Введите корректный адрес!': 'Enter a valid address!',
  'Введите адрес электронной почты!': 'Enter an email address!',
  'Пароль сохранён. Оставьте поле пустым, чтобы не менять его.': 'Password saved. Leave blank to keep it unchanged.',
  'Пароль ещё не задан.': 'No password set yet.',
  'Настройки SMTP сохранены': 'SMTP settings saved',
  'Не удалось сохранить настройки SMTP': 'Could not save SMTP settings',
  'Проверка отправки': 'Delivery test',
  'Отправить тестовое письмо на адрес': 'Send a test email to',
  'Тестовое письмо отправлено': 'Test email sent',
  'Не удалось отправить тестовое письмо': 'Could not send the test email',
  'Последнее изменение': 'Last changed',
  // Countries management
  'Страны': 'Countries',
  'Добавить страну': 'Add country',
  'Изменить страну': 'Edit country',
  'Введите название страны!': 'Enter the country name!',
  'Например: US, KG': 'e.g. US, KG',
  'Страна добавлена': 'Country added',
  'Страна обновлена': 'Country updated',
  'Страна удалена': 'Country deleted',
  'Удаление страны!': 'Delete country!',
  'Вы собираетесь удалить страну': 'You are about to delete the country',
  'Не удалось сохранить страну': 'Could not save the country',
  'Не удалось удалить страну': 'Could not delete the country',
}
